import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal } from "./Reveal";
import { PortfolioCard } from "./PortfolioCard";
import { PROJECTS } from "../data/portfolio";

export const OurWorkTeaser = () => {
  const navigate = useNavigate();
  return (
    <section className="px-5 md:px-10 py-10 md:py-16">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
              <div>
                <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">OUR WORK</p>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#F7FAFF]">
                  Recent <span className="text-gradient">Projects.</span>
                </h2>
              </div>
              <button onClick={() => navigate("/portfolio")} data-testid="teaser-view-portfolio"
                className="btn-secondary inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold min-h-[44px] self-start">
                View Full Portfolio <ArrowRight size={16} />
              </button>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {PROJECTS.slice(0, 3).map((p, i) => (
                <Reveal key={p.slug} delay={i * 0.08}><PortfolioCard project={p} /></Reveal>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
